import { render, staticRenderFns } from "./generateBrokerStatementsModal.vue?vue&type=template&id=540acc48&"
import script from "./generateBrokerStatementsModal.vue?vue&type=script&lang=js&"
export * from "./generateBrokerStatementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports